






























import { ConstructionType } from "@/api/project/construction-types-api";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ConstructionTypeTable extends Vue {
  @Prop({ required: true }) items!: ConstructionType[];

  fields = [
    { key: "id", label: "ID" },
    { key: "name", label: "工種名" },
    { key: "actions", label: "" }
  ];

  handleDelete(id: number | string, index: number) {
    this.$emit("handleDelete", id, index);
  }
}
